import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubstanceTypeEnum } from 'app/enums/substance-type-enum';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-chemical-names',
  templateUrl: './chemical-names.component.html',
  styleUrls: ['./chemical-names.component.scss']
})

export class ChemicalNamesComponent implements OnInit {
  @Input({required: true}) substanceType!: SubstanceTypeEnum;
  @Input() shouldShowFullTitle!: boolean; // Only if single entity/salt shouldn't be displayed on their respective pages.
  chemicalNames!: string;
  formType !: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.formType = this.currentForm.get('formType')?.value;
    this.chemicalNames = this.currentFormValue;
  }

  public clearChemicalNamesInputField() {
    this.chemicalNames = '';
    this.patchValueToCurrentForm();
    this.errorCheck();
  }
  public updateChemicalNames(event: Event) {
    if (event && event.type === 'blur') {
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.chemicalNames = '';
      }
    }
    this.patchValueToCurrentForm();
    this.errorCheck();
  }

  public cancelUpdate() {
    this.chemicalNames = this.currentFormValue;
    this.errorCheck();
  }

  get currentFormValue() {
    if(!this.formFieldName) {
      return '';
    }

    return this.currentForm.get(this.formFieldName)?.value;
  }

  private patchValueToCurrentForm() {
    this.formService.updateUsanFormValue(this.formFieldName, this.chemicalNames);
  }

  get isNoneChemicalNamesInputType() {
    return this.substanceType === SubstanceTypeEnum.None;
  }

  get isSingleEntityChemicalNamesInputType() {
    return this.substanceType === SubstanceTypeEnum.SingleEntity;
  }

  get isSaltChemicalNamesInputType() {
    return this.substanceType === SubstanceTypeEnum.Salt;
  }

  get formFieldName() {

    if(this.formType === 'FormF')
      return 'systematicNamesOrDescription';

    if(this.isNoneChemicalNamesInputType) {
      return 'chemicalNamesDescription';
    }

    if(this.isSingleEntityChemicalNamesInputType) {
      return 'chemicalNamesDescriptionForSingleEntity'; 
    }
    if(this.isSaltChemicalNamesInputType) {
      return 'chemicalNamesDescriptionForSaltForm'; 
    }

    return '';
  }

  get formFieldTitle() {
    var title = 'Chemical name(s)';

    if(this.isSingleEntityChemicalNamesInputType && this.shouldShowFullTitle) {
      title += ' for single entity'; 
    }
    if(this.isSaltChemicalNamesInputType && this.shouldShowFullTitle) {
      title += ' for salt form'; 
    }
    if(this.formType === 'FormF')
      title = 'Systematic Name(s) or Description';
    return title;
  }

  private errorCheck() {
    const targetControl = this.currentForm.get(this.formFieldName);
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }
}
